import memoryAxiosInstance from '../../../core/api/memoryAxios';

export const deckService = {
  list: async (userUuid: string) => {
    const response = await memoryAxiosInstance.get(`/api/v1/decks/${userUuid}`);
    return response.data;
  },
  create: async ({
    title,
    userUuid,
    icon,
    color,
  }: {
    title: string;
    userUuid: string;
    icon?: string;
    color?: string;
  }) => {
    const response = await memoryAxiosInstance.post(
      `/api/v1/decks/${userUuid}`,
      {
        title,
        userUuid,
        icon,
        color,
      }
    );
    return response.data;
  },
  get: async ({
    deckUuid,
    userUuid,
  }: {
    deckUuid: string;
    userUuid: string;
  }) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/decks/${userUuid}/${deckUuid}`
    );
    return response.data;
  },
  createFlashcard: async ({
    userUuid,
    front,
    back,
    deckUuids,
    typeName,
    isDiscipline,
    tagsUuids,
    disciplineUuid,
  }: {
    userUuid: string;
    front: string;
    back: string;
    deckUuids: string[];
    typeName: string;
    isDiscipline?: boolean;
    tagsUuids?: string[];
    disciplineUuid?: string;
  }) => {
    try {
      const response = await memoryAxiosInstance.post(
        `/api/v1/decks/${userUuid}/create-flashcard`,
        {
          front,
          back,
          deckUuids,
          typeName,
          isDiscipline,
          tagsUuids,
          disciplineUuid,
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  updateFlashcard: async ({
    userUuid,
    front,
    back,
    isDiscipline,
    flashcardUuid,
    deckUuids,
    tagsUuids,
    disciplineUuid,
  }: {
    userUuid: string;
    front: string;
    back: string;
    isDiscipline?: boolean;
    flashcardUuid: string;
    deckUuids: string[];
    tagsUuids?: string[];
    disciplineUuid?: string;
  }) => {
    try {
      const response = await memoryAxiosInstance.patch(
        `/api/v1/flashcards/${userUuid}/${flashcardUuid}`,
        {
          front,
          back,
          isDiscipline,
          deckUuids,
          tagsUuids,
          disciplineUuid,
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  updateDeck: async ({
    userUuid,
    deckUuid,
    payload,
  }: {
    userUuid: string;
    deckUuid: string;
    payload: {
      title: string;
    };
  }) => {
    const response = await memoryAxiosInstance.patch(
      `/api/v1/decks/${userUuid}/${deckUuid}`,
      payload
    );
    return response.data;
  },
  checkAvailableFlashcardsToReview: async ({
    userUuid,
    returnUuidDecks,
  }: {
    userUuid: string;
    returnUuidDecks?: boolean;
  }) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/review-flashcards/${userUuid}/check-available`,
      {
        params: {
          returnUuidDecks,
        },
      }
    );
    return response?.data;
  },
};
